import { render, staticRenderFns } from "./AssistBoard.vue?vue&type=template&id=1c401dc3&scoped=true&"
import script from "./AssistBoard.vue?vue&type=script&lang=js&"
export * from "./AssistBoard.vue?vue&type=script&lang=js&"
import style0 from "./AssistBoard.vue?vue&type=style&index=0&id=1c401dc3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c401dc3",
  null
  
)

export default component.exports